/* eslint-disable no-shadow */
/* eslint-disable react/prop-types */
import React, { useState, useEffect, useCallback } from 'react';
import _ from 'lodash';
import { gateway } from '../../../../utils/api';

import Screen from './screen';

function LaneWarningsHome({
  data,
  title,
  classes,
  onClick,
  errorWarningsMessage,
  fullButton
}) {
  const [currentPage, setCurrentPage] = useState(null);
  const [warnings, setWarnings] = useState([]);
  const [limit, setLimit] = useState(10);
  const [hasNextPage, setHasNextPage] = useState(false);
  const [loadingMore, setLoadingMore] = useState(false);

  // Extrair códigos das turmas
  const getClassCodes = useCallback(() => {
    if (!classes || !Array.isArray(classes) || classes.length === 0) {
      return [];
    }
    return classes.map(item => item.organizationCode).filter(Boolean);
  }, [classes]);

  useEffect(() => {
    if (data) {
      const docs = _.get(data, 'docs', []);
      const page = _.get(data, 'page', 1);
      const limitData = _.get(data, 'limit', 10);
      const hasNext = _.get(data, 'hasNextPage', false);
      const nextPage = _.get(data, 'nextPage', null);
      
      setLimit(limitData);
      setWarnings(docs);
      
      // Determina próxima página baseado no response
      let nextPageToSet = null;
      if (nextPage !== null) {
        nextPageToSet = nextPage;
      } else if (hasNext) {
        nextPageToSet = page + 1;
      }
      
      setCurrentPage(nextPageToSet);
      setHasNextPage(hasNext);
    }
  }, [data]);

  const getMoreWarnings = useCallback(async () => {
    // Não há próxima página ou já está carregando
    if (!hasNextPage || loadingMore || !currentPage) return;
    
    const classCodes = getClassCodes();
    if (classCodes.length === 0) return;

    try {
      setLoadingMore(true);
      const query = `?limit=${limit}&page=${currentPage}`;
      const url = `webbff/lit_app_web/classes/warnings${query}`;
      const body = { classCodes };

      const response = await gateway.post(url, body);
      const hasNext = _.get(response, 'hasNextPage', false);
      const nextPage = _.get(response, 'nextPage', null);
      const newWarnings = _.get(response, 'docs', []);

      // Atualiza estados baseado no response
      setHasNextPage(hasNext);
      
      // Determina próxima página baseado no response
      let nextPageToSet = null;
      if (nextPage !== null) {
        nextPageToSet = nextPage;
      } else if (hasNext) {
        const responsePage = _.get(response, 'page', currentPage);
        nextPageToSet = responsePage + 1;
      }
      
      setCurrentPage(nextPageToSet);
      setWarnings(prevWarnings => [...prevWarnings, ...newWarnings]);
    } catch (error) {
      console.log(error);
    } finally {
      setLoadingMore(false);
    }
  }, [currentPage, limit, hasNextPage, loadingMore, getClassCodes]);

  return (
    <Screen
      title={title}
      errorWarningsMessage={errorWarningsMessage}
      warnings={warnings}
      getMoreWarnings={getMoreWarnings}
      onClick={onClick}
      fullButton={fullButton}
    />
  );
}

export default LaneWarningsHome;

